module.exports = __webpack_public_path__ + "resources/icon_32_comment.8e5f884cde8b17ba.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_comment.png
// module id = 424
// module chunks = 0 1 2 3 4